export default {
	namespaced: true,
	state: {
		endpoint: '/nbu/person/public',
		name: 'NbuPersonPublic',
		title: {
			single: 'NbuPersonPublic',
			plural: 'NbuPersonPublics'
		},
		icon: 'mdi-account',
		item: {},
		items: [
			{
				"id": "A",
				"code": null,
				"name": "Страховий агент",
				"caption": "Страховий агент",
				"isBlocked": false
			},
			{
				"id": "S",
				"code": null,
				"name": "Субагент",
				"caption": "Субагент",
				"isBlocked": false
			},
			{
				"id": "D",
				"code": null,
				"name": "Додатковий страховий агент",
				"caption": "Додатковий страховий агент",
				"isBlocked": false
			},
			{
				"id": "1",
				"code": null,
				"name": "Страховий брокер",
				"caption": "Страховий брокер",
				"isBlocked": false
			},
			{
				"id": "2",
				"code": null,
				"name": "Перестраховий брокер",
				"caption": "Перестраховий брокер",
				"isBlocked": false
			},
			{
				"id": "3",
				"code": null,
				"name": "Страховий та перестраховий брокер",
				"caption": "Страховий та перестраховий брокер",
				"isBlocked": false
			}
		],
	},
}
